import { Chain, ChainID } from '@ankr.com/chains-list';
import { t } from '@ankr.com/common';

import { ChainPageSkeleton } from 'modules/chains/components/ChainPageSkeleton';
import {
  selectBlockchainsLoadingStatus,
  selectNodesDetailsLoadingStatus,
  selectPrivateChainById,
} from 'modules/chains/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';
import { useTokenManagerConfigSelector } from 'domains/jwtToken/hooks/useTokenManagerConfigSelector';

interface PrivateChainLoaderProps {
  Component: React.FC<{ chain: Chain }>;
  chainID: ChainID;
}

export const PrivateChainLoader = ({
  Component,
  chainID,
}: PrivateChainLoaderProps) => {
  const isLoadingChains = useAppSelector(selectBlockchainsLoadingStatus);
  const isLoadingNodes = useAppSelector(selectNodesDetailsLoadingStatus);
  const isLoading = isLoadingChains || isLoadingNodes;

  const { userEndpointToken } = useAccount();

  const { selectedProjectEndpointToken = userEndpointToken } =
    useTokenManagerConfigSelector();

  const chain = useAppSelector(state =>
    selectPrivateChainById(state, chainID, selectedProjectEndpointToken),
  );

  if (isLoading) {
    return <ChainPageSkeleton />;
  }

  if (!chain) {
    throw new Error(t('chain-item.not-found'));
  }

  return <Component chain={chain} />;
};
